import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppUserService } from 'src/app/managers/app-user.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
    @Input() homepage: boolean;

    constructor(
        private appUserService: AppUserService,
        private router: Router,
    ) { }

    logOut() {
        this.appUserService.logoutFranchiseUser();
        this.router.navigate(['authenticatecallcenter']);
    }
}